import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  /**
   * Get the current user's subscription details
   * @returns {Promise} Promise with the current subscription data
   */
  getCurrentSubscription() {
    return axios.get(`${API_URL}/api/subscription/current`);
  },

  /**
   * Get all available subscription plans
   * @returns {Promise} Promise with the available plans
   */
  getPlans() {
    return axios.get(`${API_URL}/api/subscription/plans`);
  },

  /**
   * Change the user's subscription plan
   * @param {number} planId - The ID of the plan to change to
   * @returns {Promise} Promise with the updated subscription data
   */
  changePlan(planId) {
    return axios.post(`${API_URL}/api/subscription/change`, { plan_id: planId });
  },

  /**
   * Cancel the user's subscription
   * @returns {Promise} Promise with the cancellation result
   */
  cancelSubscription() {
    return axios.post(`${API_URL}/api/subscription/cancel`);
  },

  /**
   * Resume a previously cancelled subscription
   * @returns {Promise} Promise with the resume result
   */
  async resumeSubscription() {
    return axios.post(`${API_URL}/api/subscription/resume`, 
      {},
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
  },

  /**
   * Confirm a subscription after Stripe checkout
   * @param {string} sessionId - The Stripe checkout session ID
   * @returns {Promise} Promise with the confirmation result
   */
  async confirmSubscription(sessionId) {
    return axios.post(`${API_URL}/api/subscription/confirm`, 
      {
        session_id: sessionId
      },
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
  },

  // Get payment history
  async getPaymentHistory() {
    try {
      const response = await axios.get(`${API_URL}/api/subscription/payment-history`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          Accept: 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching payment history:', error);
      throw error;
    }
  }
}; 